import { Box, Button, ListItem, ListItemText, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { WalletDetailsItem } from './wallet-details-item.component'
import { IUserWalletBase } from 'src/types'
import { HelperWrapper } from 'src/components/helper-wrapper'

interface IProps {
  wallets: Omit<IUserWalletBase, 'privateKey'>[]
  handleMakeWalletActive: (address: string) => Promise<void>
  handleDisconectSelfManagedWallet: (address: string) => Promise<void>
}

export const UserWalletsDetailsMobile = ({
  wallets,
  handleMakeWalletActive,
  handleDisconectSelfManagedWallet,
}: IProps) => {
  const [t] = useTranslation()
  const theme = useTheme()

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '700px',
        px: '6px',
        overflowX: 'auto',
      }}
    >
      {wallets.map((wallet) => (
        <WalletDetailsItem key={wallet.address} wallet={wallet}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              px: '18px',
            }}
          >
            <ListItem disablePadding>
              <ListItemText
                primary={t('user-wallet-scans-label.v') + ':'}
                primaryTypographyProps={{ style: { fontSize: '14px' } }}
                secondary={wallet.scans || 0}
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemText
                primary={t('user-wallet-trai-balance-label.v') + ':'}
                primaryTypographyProps={{ style: { fontSize: '14px' } }}
                secondary={wallet.trai_balance || 0}
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemText
                primary={t('user-wallet-eth-balance-label.v') + ':'}
                primaryTypographyProps={{ style: { fontSize: '14px' } }}
                secondary={wallet.eth_balance || 0}
              />
            </ListItem>
            <ListItem disablePadding>
              <ListItemText
                primary={t('user-wallet-type-label.v') + ':'}
                primaryTypographyProps={{ style: { fontSize: '14px' } }}
                secondary={
                  wallet.is_custodial
                    ? t('user-wallet-custodial-type-label.v')
                    : t('user-wallet-self-managed-type-label.v')
                }
              />
            </ListItem>
            {!wallet.active && (
              <Box sx={{ width: '100%' }}>
                <Button
                  size="small"
                  variant="text"
                  sx={{ textTransform: 'none' }}
                  onClick={() => handleMakeWalletActive(wallet.address)}
                >
                  <HelperWrapper t={'user-wallet-make-default-button-label'} />
                </Button>
              </Box>
            )}

            {!wallet.is_custodial && !wallet.active && (
              <Box sx={{ width: '100%' }}>
                <Button
                  size="small"
                  variant="text"
                  sx={{ textTransform: 'none', color: theme.palette.custom.warning2 }}
                  onClick={() => handleDisconectSelfManagedWallet(wallet.address)}
                >
                  <HelperWrapper t={'user-wallet-remove-self-managed-button-label'} />
                </Button>
              </Box>
            )}
          </Box>
        </WalletDetailsItem>
      ))}
    </Box>
  )
}
